import type { LeadFilters } from '../hooks/queries';

const positiveInteger = (value: string | null, fallback: number) => {
  const number = Number(value);
  return Number.isSafeInteger(number) && number > 0 ? number : fallback;
};

/** Keep filters in the URL so refresh, shared links, and browser history agree. */
export const readLeadFilters = (params: URLSearchParams): LeadFilters => ({
  page: positiveInteger(params.get('page'), 1),
  pageSize: 25,
  search: params.get('search') ?? '',
  status: params.get('status') || undefined,
  leadTypeId: params.get('leadTypeId') || undefined,
  hasEmail: params.get('hasEmail') === 'true' ? true : params.get('hasEmail') === 'false' ? false : undefined,
  sortBy: params.get('sortBy') || 'createdAt',
  sortDir: params.get('sortDir') === 'asc' ? 'asc' : 'desc',
});

export const patchLeadFilters = (params: URLSearchParams, patch: Partial<LeadFilters>): URLSearchParams => {
  const next = new URLSearchParams(params);
  next.delete('page');
  for (const [key, value] of Object.entries(patch)) {
    if (value === undefined || value === '' || (key === 'page' && value === 1)) next.delete(key);
    else next.set(key, String(value));
  }
  return next;
};
